import React, { useState } from 'react';

import { Button } from 'primereact/button';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Tooltip } from 'primereact/tooltip';
import { UseFormSetValue } from 'react-hook-form';

import { AssetParameter } from '../../types/interfaces';
import { AssetForEdit } from '../../types/interfaces/AssetForEdit';

interface CharacteristicsTabContentProps {
  assetId?: number | string;
  characteristics: AssetParameter[] | undefined;
  setValue: UseFormSetValue<AssetForEdit>;
  withoutDialog: boolean;
  isMobile?: boolean
}

const CharacteristicsTabContent = ({
  assetId,
  characteristics,
  setValue,
  withoutDialog = false,
  isMobile = false
}: CharacteristicsTabContentProps) => {
  const [, forceUpdate] = useState<number>(0);

  return (
    <div
      style={isMobile ? { 
        maxHeight: '40vh',
        overflow: 'auto',
        paddingRight: '4px' 
      } : {}}
    >
      <Tooltip target=".сharacteristic-item" />

      {characteristics && characteristics.length > 0 ? (
        characteristics.map((characteristic, index) => (
          <div
            className="flex flex-row сharacteristic align-items-center card-row--bottom-margin w-full gap-3"
            key={`${index}-${characteristic.selectedValue}`}
          >
            <label
              className="font-normal сharacteristic-item task-card__label"
              style={{ width: '40%' }}
            >
              <span
                className="сharacteristic-item"
                data-pr-tooltip="Название характеристики"
                data-pr-position="top"
              >
                {characteristic?.name}
              </span>
              <span
                className="ml-1 сharacteristic-item"
                data-pr-tooltip="Единица измерения"
                data-pr-position="top"
              >
                ({characteristic?.measure?.label})
              </span>
            </label>
            {!withoutDialog ? (
              <div className="flex flex-row" style={{ width: '60%' }}>
                <Dropdown
                  value={
                    characteristic?.selectedValue !== null
                      ? characteristic.values[characteristic.selectedValue]
                      : null
                  }
                  style={{ width: '100%' }}
                  onChange={(e: DropdownChangeEvent) => {
                    const selectedValue = characteristic.values.indexOf(
                      e.value
                    );
                    setValue(
                      `parameters.${index}.selectedValue` as const,
                      selectedValue,
                      { shouldDirty: true }
                    );
                    forceUpdate((prev) => prev + 1);
                  }}
                  options={characteristic.values}
                  showClear
                  filter
                  tooltip="Выбор значения характеристики"
                  tooltipOptions={{ position: 'top' }}
                />
              </div>
            ) : (
              <InputText
                className="user-card__input asset-card--input"
                value={
                  characteristic?.selectedValue !== null &&
                  characteristic?.selectedValue !== -1
                    ? characteristic.values[characteristic.selectedValue].label
                    : ''
                }
                readOnly={true}
                tooltip="Текущее значение характеристики"
                tooltipOptions={{ position: 'top' }}
              />
            )}
          </div>
        ))
      ) : assetId ? (
        'Выбранный тип объекта не содержит характеристик или был удален'
      ) : (
        <Message severity="warn" text="Не выбран объект" />
      )}
    </div>
  );
};

export default CharacteristicsTabContent;
